module.exports = __webpack_public_path__ + "hstl3-9e20a95c.webp";